export function unwrapGameLaunchUrl(raw: string): string {
  try {
    const parsed = new URL(raw, window.location.href);
    const proxied = parsed.pathname.match(/^\/__gg\/([^/]+)(\/.*)?$/);
    if (proxied) {
      return unwrapGameLaunchUrl(
        `https://${proxied[1]}${proxied[2] || "/"}${parsed.search}${parsed.hash}`
      );
    }
    if (parsed.pathname.includes("/pages/open/index.html")) {
      const to = parsed.searchParams.get("to");
      if (to) return unwrapGameLaunchUrl(to);
    }
    if (parsed.pathname.includes("/pages/game/index.html")) {
      const storageKey = parsed.searchParams.get("storageKey");
      if (storageKey) {
        const stored = window.localStorage.getItem(storageKey);
        if (stored) {
          window.localStorage.removeItem(storageKey);
          if (!stored.trim().startsWith("<")) return stored;
        }
      }
    }
  } catch {
    // keep original
  }
  return raw;
}

export function toLobbyFrameSrc(url: string): string {
  const raw = String(url || "").trim();
  if (!raw) return raw;
  if (raw.includes("/__gg/")) return raw;
  try {
    const parsed = new URL(raw);
    if (!/^https?:$/.test(parsed.protocol)) return raw;
    const origin =
      typeof window !== "undefined" ? window.location.origin : "";
    if (process.env.NODE_ENV !== "development" || !origin) return raw;
    return `${origin}/__gg/${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return raw;
  }
}

export function isCapturedGameUrl(raw: string): boolean {
  try {
    const parsed = new URL(raw, window.location.href);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return false;
    const host = parsed.hostname.toLowerCase();
    if (host === "localhost" || host === "127.0.0.1") {
      return parsed.pathname.startsWith("/__gg/");
    }
    return !["t.me", "telegram.org", "telegram.me"].some(
      (item) => host === item || host.endsWith(`.${item}`)
    );
  } catch {
    return false;
  }
}
